
export enum UserRole {
  REQUESTER = 'requester',
  ARTISAN = 'artisan'
}

export enum RequestStatus {
  POSTED = 'Posted',
  CLARIFYING = 'Clarifying',
  OPEN = 'Open',
  LOCKED = 'Locked',
  EN_ROUTE = 'En route',
  ARRIVED = 'Arrived',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled'
}

export enum Urgency {
  ASAP = 'ASAP',
  TODAY = 'Today',
  THIS_WEEK = 'This Week'
}

export interface User {
  id: string;
  name: string;
  role: UserRole;
  city: string;
}

export interface ArtisanProfile extends User {
  skills: string[];
  serviceRadius: number;
  availableNow: boolean;
  rating: number;
}

export interface Request {
  id: string;
  requesterId: string;
  requesterName: string;
  text: string;
  mediaUrl?: string;
  category: string;
  urgency: Urgency;
  status: RequestStatus;
  location?: { lat: number; lng: number; address: string };
  createdAt: number;
  estimatedPrice?: string;
  assignedArtisanId?: string;
}

export interface Question {
  id: string;
  requestId: string;
  artisanId: string;
  artisanName: string;
  question: string;
  createdAt: number;
  answer?: string;
}

export interface Interest {
  id: string;
  requestId: string;
  artisanId: string;
  artisanName: string;
  type: 'interested' | 'accept';
  createdAt: number;
}
